import { Component, LoaderManager } from 'shimmer'
import { gui, guiObj } from '@/utils/gui'

import { lenses } from '@/assets/data'

import {
  DirectionalLight,
  AmbientLight,
  Vector3,
  Vector2,
  Box3
} from 'three'

import { webGL } from '@/webGL/WebGL'
import { textureLib } from '@/webGL/TextureLib'
import { MeshReflectorMaterial } from '@/webGL/materials/MeshReflectorMaterial'
import { Floor } from '@/webGL/objects/Floor2'
import { Screen } from '@/webGL/objects/Screen'
import { Particles } from '@/webGL/objects/Particles'

import { Lensflare, LensflareElement } from 'three/examples/jsm/objects/Lensflare'

const urls = ['/videos/test.mp4', '/videos/test-2.mp4']

export class Environment extends Component {
  constructor (name, isPBR = false, x) {
    super()

    this.name = name
    this.isPBR = isPBR

    this.promise = this.load(name)
    this.animationClip = null

    this.setupLight()
  }

  async load (name) {
    return new Promise(async resolve => {
      const screens = []
      const res = await LoaderManager.load(name, false, obj => {
        if (obj.name.startsWith('SM_SOL_REFLECTION')) {
          this.setupReflectors(obj)
        }

        if (obj.name.startsWith('SM_ECRAN_')) {
          screens.push(obj)
        }

        if (obj.name.startsWith('BLOOM_')) {
          obj.layers.enable(1)
          obj.traverse(child => child.layers.enable(1))
        }
      })
      // this.animationClip = res[0].object.animations.find(anim => anim.name.includes('CAM'))
      this.animationClip = res[0].object.animations[0]
      this.object = res[0].object.scene
      this.add(this.object)

      screens.forEach((obj, index) => {
        this.addScreen(obj, urls[index])
      })
      resolve()
    })
  }

  addScreen (mesh, url) {
    this.screen = new Screen(url, mesh)
  }

  setupReflectors (object) {
    this.floor = new Floor(object)
  }

  setupLight () {
    this.ambient = new AmbientLight(0xffffff, .4)
    this.add(this.ambient)

    const guiLight = gui.addFolder('Light')
    guiLight.add(this.ambient, 'intensity').min(0).max(2).step(0.01).name('Ambient')

    this.directional = new DirectionalLight(0xffffff, 1.1)
    this.directional.position.set(-40, 12, 17)
    this.directional.lookAt(0, 0, 0)

    guiLight.add(this.directional, 'intensity').min(0).max(5).step(0.01).name('Directionnal')
    this.add(this.directional)

    this.setupFlare()
    this.setupParticles()
  }

  setupFlare () {
    this.lensflare = new Lensflare()
    textureLib.texturesFlares.forEach((texture, index) => {
      this.lensflare.addElement(new LensflareElement( texture, lenses[index].size, lenses[index].distance ))
    })
    this.directional.add(this.lensflare)
  }

  setupParticles () {
    this.particles = new Particles({
      color: 0xfae9ef,
      size: new Box3(new Vector3(-4, 4, -4), new Vector3(4, 15, 4) ),
      speed: new Vector2(0, .1),
      particleSize: .5,
      count: 100
    })
    this.add(this.particles)
  }
}